/* eslint-disable react-hooks/exhaustive-deps */
import * as React from "react"
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil"
import layoutStates from "../../../recoil/atoms/layout"
import { Tabs } from "@chakra-ui/react"
import { UserList } from "../userList"
import { Chat } from "../chat"
import { HistoryList } from "../badges"
import { FaUsers } from "react-icons/fa"
import { ServicesTabList } from "../services-tab-list"
import { ServicesTabPanels } from "../services-tab-panels"
import { TabPanelsListProps } from "../services-tab-panels/services-tab-panels.interface"
import { TabServiceProps } from "../services-tab-list/services-tab-list.interface"
import { CollapseButton } from "../../common/collapse-button"
import { badgeHisrotyIdsSelector, unFilterHistoryListSelector } from "../../../recoil/atoms/badgeHistory"
import { IoChatbubbleSharp } from "react-icons/io5"
import { serviceTabAtom } from "../../../recoil/atoms/service-panele-tab"
import ChatCountTabIcon from "../chat/ChatCountTabIcon"
import { CHAT_DESKTOP_TAB_INDEX } from "../../../constants"
import { Icon } from "../../common/icons"
import UserListIcon from "../userList/user-list-icon"
import { useTranslation } from "react-i18next"
import { PlayIcon } from "../../common/icons/play-icon"
import Videos from "../videos"
import { shoppableVideosSelector } from "../../../recoil/selectors/shoppable-videos-selector"
import { GiShoppingBag } from "react-icons/gi"
import { brandingSelector } from "../../../recoil/atoms/room"
import { shoppableMNPVideoAtom, shoppableVideosListAtom } from "../../../recoil/atoms/shoppableVideos"
import { useLocalUserType } from "../../../hooks/useLocalUserType"
import { taggedBadgesAtom } from "../../../recoil/atoms/taggedBadges"

interface SidePanelViewProps {
  sidebarOpen: boolean
  setSidebarOpen: (boolean) => void
  gridViewEnabled: boolean
  setGridViewEnabled: (boolean) => void
  servicePanelBackgroundColor: any
  tabButtonStyle: any
  canSeeUserListTab: boolean
  canSeeChatTab: boolean
  canSeeHistoryTab: boolean
  targetTabIndex?: number
  handleTabsChange?: (index: number) => void
  handleClickChatTab: () => void
  handleClickOneTabChat: () => void
  liveSellButtonProps: {
    audienceButtonLiveSellIcon: string
    audienceButtonLiveSellText: string
  }
}

export const SidePanelView: React.FC<SidePanelViewProps> = ({
  servicePanelBackgroundColor,
  sidebarOpen,
  tabButtonStyle,
  setSidebarOpen,
  canSeeUserListTab,
  canSeeChatTab,
  canSeeHistoryTab,
  targetTabIndex,
  handleTabsChange,
  handleClickChatTab,
  handleClickOneTabChat,
  liveSellButtonProps
}) => {
  const { t } = useTranslation()
  const [isBadgesListLive] = useRecoilState<boolean>(
    layoutStates.isBadgesListLive
  )
  const originalShoppableVideosList = useRecoilValue(shoppableVideosListAtom)
  // const setChatIsRead = useSetRecoilState(chatIsReadAtom)
  const setActiveTabName = useSetRecoilState(serviceTabAtom)
  const [isOneTabBadgesHistory, setOneTabBadgesHistory] =
    useRecoilState<boolean>(layoutStates.isOneTabBadgesHistory)
  const [, setIsOneTab] = useRecoilState<boolean>(layoutStates.isOneTab)
  const setIsSidePanelWithSingleTab = useSetRecoilState(layoutStates.isSidePanelWithSingleTab)
  const unfilteredBadgeHistoryList = useRecoilValue(unFilterHistoryListSelector)
  // const allBadgeHistory = useRecoilValue(badgeHistoryListSelector)
  const allBadgeHistory = useRecoilValue(badgeHisrotyIdsSelector)
  const isShoppableVideos = useRecoilValue(shoppableVideosSelector)
  const tabPanelsList: TabPanelsListProps[] = []
  const tabList: TabServiceProps[] = []
  const roomStyles = useRecoilValue(brandingSelector)
  const [{ enabledShoppableMNP }] = useRecoilState(shoppableMNPVideoAtom)
  const { isBroadcaster } = useLocalUserType()
  // const taggedBadgesList = useRecoilValue(taggedBadgesListSelector)
  const taggedBadgesList = useRecoilValue(taggedBadgesAtom)


  if (canSeeUserListTab) {
    tabPanelsList.push({
      id: "1",
      tabPanel: <UserList />,
      styles: { height: "100%", padding: 0 }
    })

    tabList.push({
      id: "1",
      icon: <FaUsers size="1.2em" />,
      text: t("Users"),
      render: props => <UserListIcon {...props} />
    })
  }

  if (canSeeChatTab) {
    tabPanelsList.push({
      id: CHAT_DESKTOP_TAB_INDEX,
      tabPanel: (
        <Chat servicePanelBackgroundColor={servicePanelBackgroundColor} />
      ),
      styles: {
        display: "flex",
        flexDirection: "column",
        height: "100%",
        padding: 0
      }
    })

    tabList.push({
      id: CHAT_DESKTOP_TAB_INDEX,
      icon: (
        <Icon
          src={IoChatbubbleSharp}
          boxSize="1.2em"
          color="transparent"
          strokeWidth="3.5rem"
          stroke={"inherit"}
        />
      ),
      text: t("Chat"),
      render: props => <ChatCountTabIcon {...props} />,
      callback: handleClickChatTab
    })
  }

  const userCanSeeHistoryTab = canSeeHistoryTab
  const noLiveBadges = !isBadgesListLive

  const hasBadgeHistoryOrTaggedBadges = unfilteredBadgeHistoryList.length !== 0 || taggedBadgesList.length !== 0

  if (userCanSeeHistoryTab && noLiveBadges && hasBadgeHistoryOrTaggedBadges) {
    // This is history tab, but for audience and broadcasters it will be called Livesell
    tabPanelsList.push({
      id: "3",
      tabPanel: <HistoryList />,
      styles: { height: "calc(100% - 51px)", padding: 0 }
    })

    tabList.push({
      id: "3",
      icon: <Icon src={GiShoppingBag} boxSize="1.2em" strokeWidth="3px" />,
      text: t("Shop")
    })
  }

  const hasActiveShoppableVideos = originalShoppableVideosList.some(
    sv => sv.shoppableEnabled
  )

  if (isShoppableVideos && hasActiveShoppableVideos) {
    tabPanelsList.push({
      id: "4",
      tabPanel: <Videos />,
      styles: { height: "calc(100% - 51px)", padding: 0 }
    })

    tabList.push({
      id: "4",
      icon: <Icon src={PlayIcon} boxSize="1.2em" />,
      text: isBroadcaster ? t("Videos") : t("Watch"),
      customStyles: enabledShoppableMNP
        ? {
            background: `${roomStyles?.secondaryAccessButtonSelectedColor} !important`,
            color: `${roomStyles?.secondaryAccessButtonSelectedTextColor} !important`
          }
        : undefined
    })
  }

  const isOneTab = React.useMemo(() => {
    return tabPanelsList.length === 1;
  }, [tabPanelsList.length, isBadgesListLive])

  React.useEffect(() => {
    if (isBadgesListLive && canSeeChatTab) {
      setActiveTabName("Chat")
    }
  }, [isBadgesListLive, canSeeChatTab])

  React.useEffect(() => {
    setOneTabBadgesHistory(
      isOneTab && // should be one tab
      canSeeHistoryTab && // has history tab
      (allBadgeHistory.length !== 0 || taggedBadgesList.length !== 0) && // has product to show
      !isBadgesListLive // Not shown below mainVideoWindow
    )
  }, [isOneTab, canSeeHistoryTab])

  React.useEffect(() => {
    setIsOneTab(tabPanelsList.length === 1 && !isBadgesListLive)
  }, [tabPanelsList.length, isBadgesListLive])

  React.useEffect(() => {
    if (targetTabIndex + 1 > tabList.length) {
      handleTabsChange(targetTabIndex - 1)
    } else if (targetTabIndex === -1 && tabList.length > 0) {
      handleTabsChange(0)
    }
  }, [targetTabIndex, tabList.length])

  React.useEffect(() => {
    if (isOneTabBadgesHistory) {
      handleTabsChange(0)
    }
  }, [isOneTabBadgesHistory])

  React.useEffect(() => {
    if(isOneTab && !(isOneTabBadgesHistory && allBadgeHistory.length === 0)) {
      setIsSidePanelWithSingleTab(true)
    } else {
      setIsSidePanelWithSingleTab(false)
    }
  }, [isOneTab, isOneTabBadgesHistory, allBadgeHistory.length])

  // tab is 0 or one tab of history but live badge is off
  const hideTab = tabPanelsList.length === 0

  return (
    <Tabs
      isLazy
      display={hideTab ? "none" : "flex"}
      id="TABS"
      lazyBehavior="keepMounted"
      position="relative"
      variant="line"
      orientation="vertical"
      height="100%"
      index={targetTabIndex}
      onChange={handleTabsChange}
    >

    {isOneTab && !(isOneTabBadgesHistory && allBadgeHistory.length === 0) && (
        <CollapseButton
          setSidebarOpen={setSidebarOpen}
          sidebarOpen={sidebarOpen}
          tabButtonStyle={tabButtonStyle}
          isOneTab={isOneTab}
          servicePanelBackgroundColor={servicePanelBackgroundColor}
          handleClickChatTab={handleClickOneTabChat}
          canSeeChatTab={canSeeChatTab}
        />
      )}

      {!(isOneTabBadgesHistory && allBadgeHistory.length === 0) && (
        <ServicesTabPanels
          sidebarOpen={sidebarOpen}
          servicePanelBackgroundColor={servicePanelBackgroundColor}
          tabPanelsList={tabPanelsList}
        />
      )}

      {!isOneTab && (
        <ServicesTabList
          setSidebarOpen={setSidebarOpen}
          sidebarOpen={sidebarOpen}
          tabList={tabList}
          tabButtonStyle={tabButtonStyle}
          showCollapseButton={true}
        />
      )}
    </Tabs>
  )
}
